<mat-form-field class="search-input">
  <input placeholder="Filter"
    matInput
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="addOnBlur"
    (matChipInputTokenEnd)="applyFilter($event)"
    [disabled]="disabled">
    <mat-chip-grid #chipList>
    </mat-chip-grid>
  </mat-form-field>
  @for (item of searchItems; track item) {
    <mat-chip-option
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(item)">
      {{item.name}}
      @if (removable) {
        <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-option>
  }